import { Component, EventEmitter, Input } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { isNullOrUndefined } from '@uzurv/core';
import { GenericListSelectHandlerData } from './generic-list-select-handler-data';

@Component({
  selector: 'app-generic-list-select',
  templateUrl: './generic-list-select.component.html',
  styleUrls: ['./generic-list-select.component.scss']
})
export class GenericListSelectComponent {
  @Input() testingId = null;
  @Input() data: any;
  @Input() value: any;
  @Input() choices: Array<any>;
  @Input() clickHandler: EventEmitter<GenericListSelectHandlerData>;
  @Input() disabled = false;

  handleSelect(event: MatSelectChange) {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, clickEvent: event });
    }
  }
}
